import { render, staticRenderFns } from "./FinancialReports.vue?vue&type=template&id=65f72366&scoped=true"
import script from "./FinancialReports.vue?vue&type=script&lang=js"
export * from "./FinancialReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f72366",
  null
  
)

export default component.exports